import React, { useState } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import { v4 as uuidv4 } from 'uuid';
import { client } from '../client';

const Comment = ({ commentText, key, userId }) => {
    const [popup, setPopup] = useState(false);
    const [comment, setComment] = useState('');
    const [addingComment, setAddingComment] = useState(false);

    const addComment = () => {
        console.log("comment attempt, key: " + key);
        console.log(comment);
        // if (comment) {
        //     setAddingComment(true);
        //     client
        //         .patch(_id)
        //         .setIfMissing({ comments: [] })
        //         .insert('after', 'comments[-1]', [{ comment, _key: uuidv4(), postedBy: { _type: 'postedBy', _ref: userId } }])
        //         .commit()
        //         .then(() => {
        //             // fetchPinDetails();
        //             setComment('');
        //             setAddingComment(false);
        //         });
        // }
    };

    return (
        <div>
            <button
                className='justify-start md:hover:shadow-lg'
                onClick={() => setPopup(true)}>
                <p className='text-left'>{commentText}</p>
            </button>
            {popup && (
                <ClickAwayListener onClickAway={() => setPopup(false)}>
                    <div className="flex flex-wrap mt-6 gap-3">
                        <input
                            className=" flex-1 border-gray-100 outline-none border-2 p-2 rounded-2xl focus:border-gray-300"
                            type="text"
                            placeholder="Add a comment"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                        />
                        <button
                            type="button"
                            className="bg-indigo-500 text-white rounded-full px-6 py-2 font-semibold text-base outline-none"
                            onClick={addComment}
                        >
                            {addingComment ? 'Commenting...' : 'Comment'}
                        </button>
                    </div>
                </ClickAwayListener>
            )}
        </div>
    )
}

export default Comment
